<template>
  <div>
    <div class="header">
      <div class="container">
        <div class="logo">
          <router-link to="/">
            <img :src="fourLapsLogo" />
          </router-link>
        </div>
        <div v-if="isLogged()" class="hamburger" @click="toggleMenu">
          <svg
              width="25"
              height="15"
              viewBox="0 0 25 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M23.6806 6.25006H1.31944C0.590735 6.25006 0 6.78172 0 7.43756V7.56256C0 8.2184 0.590735 8.75006 1.31944 8.75006H23.6806C24.4093 8.75006 25 8.2184 25 7.56256V7.43756C25 6.78172 24.4093 6.25006 23.6806 6.25006Z"
                fill="black"
            ></path>
            <path
                d="M23.6806 12.5001H1.31944C0.590735 12.5001 0 13.0317 0 13.6876V13.8126C0 14.4684 0.590735 15.0001 1.31944 15.0001H23.6806C24.4093 15.0001 25 14.4684 25 13.8126V13.6876C25 13.0317 24.4093 12.5001 23.6806 12.5001Z"
                fill="black"
            ></path>
            <path
                d="M23.6806 6.10352e-05H1.31944C0.590735 6.10352e-05 0 0.531723 0 1.18756V1.31256C0 1.9684 0.590735 2.50006 1.31944 2.50006H23.6806C24.4093 2.50006 25 1.9684 25 1.31256V1.18756C25 0.531723 24.4093 6.10352e-05 23.6806 6.10352e-05Z"
                fill="black"
            ></path>
          </svg>
        </div>
        <span v-if="$route.name === 'Home'">
<!--          Станьте нашим клиентом &mdash;-->
<!--          <router-link to="/registration">Зарегистрируйтесь</router-link>-->
        </span>
        <span v-if="$route.name === 'Registration'">
          Уже есть аккаунт &mdash; <router-link to="/">войти</router-link>
        </span>
        <span v-if="$route.name === 'Password recovery'">
          <router-link to="/">Войти</router-link>
        </span>

        <Logout />
      </div>
    </div>

    <div v-if="isLogged()" class="mobile_menu" :class="{ show: menuIsVisible }">
      <a class="close_menu" href="" @click.prevent="toggleMenu">
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M9.87818 7.99886L15.606 2.28357C15.8568 2.03271 15.9977 1.69246 15.9977 1.33769C15.9977 0.98291 15.8568 0.642664 15.606 0.391799C15.3552 0.140934 15.015 0 14.6602 0C14.3055 0 13.9653 0.140934 13.7145 0.391799L8 6.12041L2.28552 0.391799C2.03469 0.140934 1.6945 -2.64329e-09 1.33977 0C0.985044 2.64329e-09 0.644846 0.140934 0.394017 0.391799C0.143188 0.642664 0.00227327 0.98291 0.00227327 1.33769C0.00227327 1.69246 0.143188 2.03271 0.394017 2.28357L6.12182 7.99886L0.394017 13.7142C0.269166 13.838 0.17007 13.9853 0.102444 14.1477C0.0348177 14.31 0 14.4842 0 14.66C0 14.8359 0.0348177 15.01 0.102444 15.1724C0.17007 15.3347 0.269166 15.4821 0.394017 15.6059C0.517848 15.7308 0.665174 15.8299 0.827496 15.8975C0.989818 15.9652 1.16392 16 1.33977 16C1.51562 16 1.68972 15.9652 1.85204 15.8975C2.01437 15.8299 2.16169 15.7308 2.28552 15.6059L8 9.87731L13.7145 15.6059C13.8383 15.7308 13.9856 15.8299 14.148 15.8975C14.3103 15.9652 14.4844 16 14.6602 16C14.8361 16 15.0102 15.9652 15.1725 15.8975C15.3348 15.8299 15.4822 15.7308 15.606 15.6059C15.7308 15.4821 15.8299 15.3347 15.8976 15.1724C15.9652 15.01 16 14.8359 16 14.66C16 14.4842 15.9652 14.31 15.8976 14.1477C15.8299 13.9853 15.7308 13.838 15.606 13.7142L9.87818 7.99886Z"
              fill="black"
          ></path></svg
        ></a>

      <div class="left">
        <div class="user">
          <UserWidget />
        </div>
        <div class="left_menu">
          <LeftMenu />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useKitImg from "../../assets/img/logo.svg";
import Logout from "@/components/4laps/Logout";
import LeftMenu from "@/components/4laps/LeftMenu";
import UserWidget from "@/components/4laps/UserWidget";
import { isLogged } from "@/helpers/authHelper";
import fourLapsLogo from "@/assets/FourLapsLogo.svg";

export default {
  name: "Header",
  data() {
    return {
      useKitImg,
      menuIsVisible: false,
      isLogged,
      fourLapsLogo,
    };
  },
  components: {
    Logout,
    LeftMenu,
    UserWidget,
  },
  methods: {
    toggleMenu() {
      this.menuIsVisible = !this.menuIsVisible;
    },
  },
};
</script>

<style scoped>
#header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.menu-fixed {
  position: fixed;
  right: 0;
  top: 0;
}
</style>

<style>
@media (max-width: 1000px) {
  #user-widget > div.top > div.edit > button {
    margin-right: 60px;
  }
}

@media (min-width: 1001px) {
  .mobile_menu {
    display: none !important;
  }
}
</style>
